module.exports = __webpack_public_path__ + "static/media/modal-selfie-1-desktop.1ecc297d.png";